import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContainerWrapper, Title, CollapsWrapper, ListItem, List, TabsWrapper } from './style';
import useCurrentLang from '@/hooks/useCurrentLang';
import useResize from '@/hooks/useResize';
import { getFAQ } from '@/api/frontData.api';
import { sify } from 'chinese-conv/dist'
import { errorHandler } from '@/utils/toastHandler';
import { Collapse } from '@mui/material';
import { ArrowRightNoBGSVG } from '@/components/Icon';

const FAQ = () => {
  // @ts-ignore
  const { t } = useTranslation();
  const lang = useCurrentLang();
  const { isTablet, isMobile } = useResize();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<FAQ[]>([]);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [tabTypes, setTabTypes] = useState<{ key: string; title: string }[]>([]);
  const [originalData, setOriginalData] = useState<FAQ[]>([]);
  const FAQTypes = t('pages.index.Pricing.FAQTypes', { returnObjects: true });

  const getCurrentTypeData = (key: string) => {
    // 查看當前tab的index, 並將tabTypes中的key與originalData中的type進行比對, 將符合的資料放入currentTypeData中
    const currentTypeData = originalData.filter((item) => item.type === key);
    setData(currentTypeData);
  }

  const initData = async () => {
    setIsLoading(true);
    try {
      const res = (await getFAQ()).data;

      setOriginalData(res);
      // 先將res中所有出現過的type整理成一個陣列, 且不重複, 並將空白的type刪除
      const filteredRes = res.filter((item) => item.type !== '');
      const types = filteredRes.map((item) => item.type);
      const uniqueTypes = Array.from(new Set(types));
      // 將uniqueTypes透過map去尋找FAQTypes中的key並取出FAQTypes中的title作為最終翻譯的文字
      const translatedTypes = uniqueTypes.map((type) => {
        const typeIndex = FAQTypes.findIndex((item) => item.key === type);
        return typeIndex !== -1 ? FAQTypes[typeIndex] : { key: type, title: type };
      });
      // 將translatedTypes中的title設置為tabTypes
      setTabTypes(translatedTypes);
      getCurrentTypeData(translatedTypes[0].key);
    } catch (error) {
      console.log(error);
      errorHandler(t('error.server'));
    } finally {
      setIsLoading(false);
    }
  };

  const [collapseStates, setCollapseStates] = useState<boolean[]>([]);

  const handleClick = (index: number) => {
    setCollapseStates((prevStates) => {
      const newStates = [...prevStates];
      newStates[index] = !newStates[index]; // 切換指定 index 的開關狀態
      return newStates;
    });
  };

  useEffect(() => {
    initData();
  }, [lang])

  useEffect(() => {
    // 初始化 collapseStates，根據 data 的長度設置為全關閉狀態
    setCollapseStates(new Array(data.length).fill(false));
  }, [data]);

  useEffect(() => {
    if (tabTypes.length === 0) return;
    getCurrentTypeData(tabTypes[activeIndex].key);
  }, [activeIndex])

  useEffect(() => {
    if (tabTypes.length === 0) return;
    // 初始化 collapseStates，根據 data 的長度設置為全關閉狀態
    getCurrentTypeData(tabTypes[activeIndex].key);
  }, [originalData, tabTypes])

  return (
    <ContainerWrapper>
      <div id="FAQ" />
      <Title>{t('pages.index.Pricing.faq')}</Title>
      <TabsWrapper isTablet={isTablet} isMobile={isMobile}>
        {tabTypes.map((tab, index) => (
          <div
            className={`tab ${index === activeIndex ? 'active' : ''}`}
            onClick={() => setActiveIndex(index)}
            key={'tab_'+tab.key}
          >
            {tab.title}
          </div>
        ))}
      </TabsWrapper>
      {data.map((item, index) => (
        <div key={item.title_en}>
          <List>
            <ListItem onClick={() => handleClick(index)}>
              <ArrowRightNoBGSVG
                width={isTablet ? 20 : isMobile ? 16 : 24}
                height={isTablet ? 20 : isMobile ? 16 : 24}
                fill="#000"
                style={{
                  transform: collapseStates[index] ? 'rotate(90deg)' : 'rotate(0deg)',
                }}
              />
              {lang === 'en' ? item.title_en : lang === 'tc' ? item.title : sify(item.title)}
            </ListItem>
          </List>
          <Collapse in={collapseStates[index]} timeout="auto" unmountOnExit>
            <CollapsWrapper
              dangerouslySetInnerHTML={{
                __html: lang === 'en' ? item.info_en : lang === 'tc' ? item.info : sify(item.info),
              }} />
          </Collapse>
        </div>
      ))}
    </ContainerWrapper>
  );
};

export default FAQ;
